import React, { useEffect } from 'react';
import queryString from 'query-string';
import Main from 'components/pages/Main';
import NotFound from 'components/pages/NotFound';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { PIPEDRIVE_API } from 'api/pipedrive';
import { getDealMapping } from 'utils/utils';

function DealView(props) {
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch(location.pathname);
  const query = queryString.parse(location.search);
  const dealId = query.id ? query.id : null;
  const dispatch = useDispatch()
  const states = useSelector(state => {
    return state.globalStates
  })
  useEffect(() => {
    filterDealData();
  }, [dealId])
  const filterDealData = () => {
    if(dealId) {
      PIPEDRIVE_API.getDealData(dealId).then((data) => {
        const dealData = getDealMapping(data);
        if(dealData) {
          updateStates(dealData);
        }
      })
    } else {
      history.push('/');
    }
  }
  const updateStates = (dealObj) => {
    for( const item in dealObj ) {
      dispatch({
        type: `UPDATE_${ item.toUpperCase() }`,
        payload: dealObj[item]
      })
    }
  }
  return(
    <div>
      {
        dealId ? 
        <Main/> : <NotFound/>
      }
    </div>
  )
}

export default DealView;